var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gotop"},[(_vm.isActive)?_c('div',{staticClass:"go-btn",attrs:{"id":"toTop"},on:{"click":_vm.toTop}},[_c('img',{attrs:{"src":"https://caifung.oss-cn-hangzhou.aliyuncs.com/official/arrow.png"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b254a26","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gotop.vue
// module id = null
// module chunks = 